var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Observable } from 'rxjs/Observable';
import { switchMap, take } from 'rxjs/operators';
import { push, remove, set, update } from './http-actions';
var ListObservable = /** @class */ (function (_super) {
    __extends(ListObservable, _super);
    function ListObservable(ref$, apiHttp, store, errorTracking, source) {
        var _this = _super.call(this) || this;
        _this.ref$ = ref$;
        _this.apiHttp = apiHttp;
        _this.store = store;
        _this.errorTracking = errorTracking;
        _this.source = source;
        return _this;
    }
    ListObservable.prototype.push = function (object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) {
            return push(ref, object, _this.store, _this.apiHttp, _this.errorTracking);
        }))
            .toPromise();
    };
    ListObservable.prototype.set = function (id, object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) {
            return set(ref, id, object, _this.store, _this.apiHttp, _this.errorTracking);
        }))
            .toPromise();
    };
    ListObservable.prototype.update = function (id, object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) {
            return update(ref, id, object, _this.store, _this.apiHttp, _this.errorTracking);
        }))
            .toPromise();
    };
    ListObservable.prototype.remove = function (id) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) {
            return remove(ref, id, _this.store, _this.apiHttp, _this.errorTracking);
        }))
            .toPromise();
    };
    return ListObservable;
}(Observable));
export { ListObservable };



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/list-observable.ts.pre-build-optimizer.js